import styled from "styled-components";
import { Switch, Paper } from "@mui/material";

const UserContent = styled.div`
  height: 100vh;
  font-family: ${(props) => props.theme.fonts.family.inter};
`;

const UserWrapper = styled.div`
  display: flex;
  margin-top: 20px;
`;

const UserDetails = styled.div`
  flex: 1;
  margin-right: 20px;
`;

const UserActions = styled.div`
  flex: 1;
`;

const UserLabel = styled.label`
  color: #717171;
`;

const UserColumnContainer = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  gap: 10px;

  span {
    flex: 1;
  }
`;

const UserColumn = styled.div`
  margin-top: 20px;
`;

const UserPhone = styled.div`
  flex: 1;
`;

const StyledSwitch = styled(Switch)`
  && {
    .MuiSwitch-switchBase.Mui-checked {
      color: ${(props) => props.theme.colors.black};

      & + .MuiSwitch-track {
        background-color: ${(props) => props.theme.colors.clearBlue};
        opacity: 1;
      }

      & > .MuiSwitch-thumb {
        background-color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  width: 800px;
  height: 40px;
  padding: 8px;
  margin-top: 8px;
  gap: 8px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.primaryWhite};

  p {
    margin-left: 8px;
    color: ${(props) =>
      props.multiOwners
        ? props.theme.colors.clearGray
        : props.theme.colors.darkGray};
  }
`;

const StyledPaper = styled(Paper)`
  && {
    background-color: ${(props) => props.theme.colors.highClearGray};
    padding: 1rem;
    width: 250px;
    max-height: 160px;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 8px;

    & > ul {
      border-radius: 8px;
      background-color: ${(props) => props.theme.colors.white};
      border: 1px solid ${(props) => props.theme.colors.clearGray};

      & > li {
        border-bottom: 1px solid ${(props) => props.theme.colors.clearGray};
        font-family: ${(props) => props.theme.fonts.family.inter};
        padding: 10px 16px;

        &:last-child {
          border-bottom: none;
        }

        &[aria-disabled="true"] {
          font-style: italic;
          color: ${(props) => props.theme.colors.gray};
        }
      }
    }
  }
`;

export {
  UserContent,
  UserWrapper,
  UserDetails,
  UserActions,
  UserLabel,
  UserColumnContainer,
  UserColumn,
  UserPhone,
  StyledSwitch,
  SwitchContainer,
  StyledPaper,
};
